import React from 'react'
//import Table from '../common/Table'
import TableUpdated from '../common/TableUpdated.jsx'
import ShopListTable from "../common/TableComponents/ShopTable.jsx";
//import ShopListTable from "../common/ShopTable.jsx";

const ShopDashboard = ({ onOpenShopLogs }) => {
  return (
    <div className="bg-stone-100 h-full overflow-hidden">
      <div className="h-full">
        <ShopListTable onOpenShopLogs={onOpenShopLogs} />
      </div>
    </div>
  );
};

export default ShopDashboard;